import React, { useReducer } from 'react';
import DeviceProfileContext from './deviceProfileContext';
import deviceProfileReducer from './deviceProfileReducer';

import clienteAxios from '../../service/axios';

import { 
    OBTENER_DEVICE_PROFILES,
    AGREGAR_MARCA,
    ELIMINAR_MARCA,
    ACTUALIZAR_DEVICE_PROFILE,
    MARCA_ERROR,
    MARCA_OK,
    MARCA_ACTUAL,
    OBTENER_DEVICE_PROFILE,
} from 'types/context';

const DeviceProfileState = props => {
    const initialState = {
        deviceProfiles : [], // grupos del cliente
        deviceProfile: null,
        cliente: null,
        formulario : false,
        errorformulario: false,        
        mensaje: null
    }

    const [ state, dispatch ] = useReducer(deviceProfileReducer, initialState);
    const tempArr = []
    let tempMarca
    const obtenerDeviceProfiles = async () => {
        try {
            // siempre deberia venir un cliente
            let resultado = await clienteAxios.get(`/deviceProfiles`); 
            dispatch({
                type: OBTENER_DEVICE_PROFILES,
                payload: resultado.data.data?resultado.data.data.result:resultado
            });
            return resultado.data.data?resultado.data.data.result:resultado          
        } catch (error) {
            const alerta = {
                msg: error,
                categoria: 'error'
            }            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return(error)
        }
    }

    // Agregar nuevo grupo
    const agregarDeviceProfile = async (deviceProfile) => {
              
        try {
            const resultado = await clienteAxios.post('/deviceProfiles',deviceProfile);
            
            // Insertar el grupo en el estado
            /*dispatch({
                type: AGREGAR_MARCA,
                payload: resultado.data.deviceProfile
            })*/
            const alerta = {
                msg: "deviceProfile agregada con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    // Selecciona el grupo que el usuario dio click
    const marcaActual = marcaId => {
        dispatch({
            type: MARCA_ACTUAL,
            payload: marcaId
        })
    }

    // Elimina una deviceProfile
    const eliminarDeviceProfile = async marcaId => {
        try {
            const resultado = await clienteAxios.delete(`/deviceProfiles/${marcaId}`);
            
            const alerta = {
                msg: 
                    resultado.data?
                        resultado.data.error?
                            resultado.data.error
                        :"deviceProfile eliminado con exito"
                    :"error",
                categoria: 
                    resultado.data?
                        resultado.data.error?
                            "error"
                        :"exito"
                    :"error"
            }
            if (resultado.data){
                if(resultado.data.error){
                    dispatch({
                        type: MARCA_ERROR,
                        payload: alerta
                    })
                }else{
                    dispatch({
                        type: MARCA_OK,
                        payload: alerta
                    })
                }
            }else{
                dispatch({
                    type: MARCA_ERROR,
                    payload: alerta
                })  
            }
            
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
        }
    }

    // Aactualizar grupo
    const actualizarDeviceProfile = async deviceProfile => {
       
        try {
            const resultado = await  clienteAxios.put(`/deviceProfiles/${deviceProfile.id}`, deviceProfile );
            // Actualizo el disp en el state
            /*dispatch({
                type: ACTUALIZAR_DEVICE_PROFILE,
                payload: resultado.data.deviceProfile
            }) */
            const alerta = {
                msg: "deviceProfile editado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: MARCA_OK,
                payload: alerta
            })
             return resultado.status
        } catch (error) {
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
            return alerta
        }
    }

    // muestra un error de validacion
    const errorMarca = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: MARCA_ERROR,
            payload: alerta
        })
    }
    const OkMarca = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: MARCA_OK,
            payload: alerta
        })
    }
    const clearErrorMarca = () => {
        dispatch({
            type: MARCA_ERROR,
            payload: null,
        });
        };

    const clearOkMarca = () => {
        dispatch({
            type: MARCA_OK,
            payload: null,
        });
    };

    // Obtengo un grupo por id
    const obtenerDeviceProfile = async (deviceProfileId) => {
        try {           
            const resultado = await clienteAxios.get(`/deviceProfiles?id=${deviceProfileId}`);                   
            dispatch({
                type: OBTENER_DEVICE_PROFILE,
                payload: resultado.data.data ? resultado.data.data.deviceProfile:resultado
            })            
            return resultado.data.data?resultado.data.data.deviceProfile:resultado
      
        } catch (error) {
            const alerta = {
                msg: error,
                categoria: 'error'
            }            
            dispatch({
                type: MARCA_ERROR,
                payload: alerta
            })
        }
    }
    // completar dispatch
    const obtenerOrganizations = async() => {
        try {
            const resultado = await clienteAxios.get(`/deviceProfiles/organizations`);
            return resultado.data?resultado.data.result:[]
        } catch (error) {
            return []
        }
    }
    const clearAll = () =>{
        dispatch({
            type: OBTENER_DEVICE_PROFILE,
            payload:null
        })
        dispatch({
            type: OBTENER_DEVICE_PROFILES,
            payload:[]
        })
    }
    return(
        <DeviceProfileContext.Provider
            value={{
                deviceProfiles: state.deviceProfiles,
                deviceProfile: state.deviceProfile,
                cliente: state.cliente,
                formulario: state.formulario,
                errorformulario: state.errorformulario,                
                mensaje: state.mensaje,
                obtenerDeviceProfiles,
                obtenerOrganizations,
                obtenerDeviceProfile,
                agregarDeviceProfile,
                marcaActual,
                clearErrorMarca,
                clearOkMarca,
                eliminarDeviceProfile,
                actualizarDeviceProfile,
                errorMarca,
                OkMarca,
                clearAll,
            }}
        >{props.children}

        </DeviceProfileContext.Provider>
    )
}
export default DeviceProfileState;
